import { format, nextWednesday } from "date-fns";
import { getBookingConfig, logError } from "../data/price";
import { DeliveryService } from "./DeliveryService";
import { addDays } from "../components/utils/stateHelper";

// TODO: Apply to DPDPointPickupReturn.tsx (DPD Point delivery and pickup)
export class DPDDeliveryService extends DeliveryService {

    /////////////////////////////////////////////
    // Functions related to DPD logistics
    /////////////////////////////////////////////

    /**
     * The soonest that a play date can be scheduled, given a particular startDate
     */
    public static earliestPlayStartAfter(startDate: Date) {
        return addDays(DPDDeliveryService.earliestDeliveryDateAfter(startDate), 1);
    }

    /**
     * The earliest delivery date (BEFORE play start) that can be achieved given a particular
     * start date (shipping date).
     */
    public static earliestDeliveryDateAfter(startDate: Date) {
        const country = getBookingConfig()['country'] ?? 'be';
        return DeliveryService.addBusinessDays(startDate, country === 'be' ? 3 : 4);
    }

    /**
     * The day on which a package must be shipped to arrive the business day before the given playStart
     */
    public static latestShippingDateBefore(playStart: Date) {
        const country = getBookingConfig()['country'] ?? 'be';
        // It needs to be given 3 business days of shipping + it needs to arrive at least a business day before the playStart
        return DeliveryService.subtractBusinessDays(playStart, country === 'be' ? 4 : 5);
    }

    /**
     * The first day on which a package can be returned to the DPD point
     */
    public static earliestReturnDateAfter(playEnd: Date) {
        return DeliveryService.findNextWorkingDate(playEnd);
    }

    /**
     * The day we expect to receive the package back from the DPD point.
     */
    public static endDateByReturnDate(returnDate: Date) {
        return DeliveryService.addBusinessDays(returnDate, 1);
    }
}
